import classNames from 'classnames';
import * as React from 'react';

import css from './BookingWithPageDetailImage.module.scss';

interface Props {
  name: string;
  primaryImage: {
    meta: {
      width: number;
      height: number;
    };
    thumb?: {
      url: string;
    };
  };
}

const BookingWithPageDetailImage = (props: Props) => {
  const {
    name,
    primaryImage: {
      meta: { width, height },
      thumb,
    },
  } = props;
  const classes = classNames(css.BookingWithPageDetailImage, {
    [css.isLargePortrait]: width >= 640 && height > width,
    [css.isMiddle]: width < 640 && width >= 400,
    [css.isSmall]: width < 400 && width >= 200,
    [css.isTiny]: width < 200,
  });

  return <img className={classes} src={thumb!.url} alt={name} />;
};

export default BookingWithPageDetailImage;
